/*
 * Copyright (C) 2018 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { TenantManagementState } from './tenant-management.state';
import * as tenantManagementAction from './tenant-management.actions';

export function reducer(
  state: TenantManagementState,
  action: tenantManagementAction.All
): TenantManagementState {
  switch (action.type) {
    case tenantManagementAction.SELECT_TENANT_DETAILS:
      return {
        ...state,
        selectedTenant: {
          error: undefined,
          loading: false,
          data: action.tenantDetails
        }
      };

    case tenantManagementAction.SHOW_TENANT_CREATION_WIZARD:
      return {
        ...state,
        tenantCreationWizardShown: true
      };

    case tenantManagementAction.HIDE_TENANT_CREATION_WIZARD:
      return {
        ...state,
        tenantCreationWizardShown: false
      };

    case tenantManagementAction.SHOW_USER_CREATION_WIZARD:
      return {
        ...state,
        userCreationWizardShown: true
      };

    case tenantManagementAction.HIDE_USER_CREATION_WIZARD:
      return {
        ...state,
        userCreationWizardShown: false
      };
  }

  return state;
}
